import { Outlet } from 'react-router-dom';
import { PublicHeader } from '@/components/layout/PublicHeader';
import { Footer } from '@/components/layout/Footer';
import { MAIN_CONTENT_ID } from '@/lib/constants/layout';

export function PublicLayout() {
  return (
    <div className="min-h-screen flex flex-col">
      <PublicHeader />
      <main className="flex-1" id={MAIN_CONTENT_ID}>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
